const Header = () => {
  return (
    <div className="header-container">
      <div className="header-content"></div>
    </div>
  );
};

export default Header;
